
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import toast, { Toaster } from 'react-hot-toast';
import i18n from '../i18/i18'

const ReactSwal = withReactContent(Swal)

export const AlertService = {


    warning: async (title: string | JSX.Element, content: string | JSX.Element, preConfirm: () => any, confirmButtonText = i18n.t('btn-continue') ) => {
        const { isConfirmed } = await ReactSwal.fire({
            title: title,
            html: content,
            icon: 'warning',
            iconColor: '#f5ca99',
            confirmButtonText: confirmButtonText,
            cancelButtonText: i18n.t('btn-cancel'),
            customClass: {
                cancelButton: 'btn btn-white order-1  me-3',
                confirmButton: 'btn btn-primary order-2',
            },
            buttonsStyling: false,
            showConfirmButton: true,
            focusDeny: true,
            focusCancel: true,
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: preConfirm
        })

        return isConfirmed
    },
    success: async (title: string | JSX.Element, content: string | JSX.Element, confirmButtonText= 'OK') => {
        const { isConfirmed } = await ReactSwal.fire({
            title: title,
            html: content,
            icon: 'success',
            // iconColor: '#f5ca99',
            confirmButtonText: confirmButtonText,
            customClass: {
                cancelButton: 'btn btn-white order-1  me-3',
                confirmButton: 'btn btn-primary order-2',
            },
            buttonsStyling: false,
        })

        return isConfirmed
    },
    error: async (title: string | JSX.Element, content: string | JSX.Element, confirmButtonText= 'OK') => {
        const { isConfirmed } = await ReactSwal.fire({
            title: title,
            html: content,
            icon: 'error',
            // iconColor: '#f5ca99',
            confirmButtonText: confirmButtonText,
            customClass: {
                cancelButton: 'btn btn-white order-1  me-3',
                confirmButton: 'btn btn-primary order-2',
            },
            buttonsStyling: false,            
        })

        return isConfirmed
    },

    toastLoading: (promise, loadingMessage, successMessage, errorMessage ) => {
        toast.promise(promise, {
            loading: loadingMessage,
            success: successMessage,
            error: errorMessage,
            
        }, {
            duration: 4000,
            style: {
                // borderRadius: '10px',
                background: '#333',
                color: '#fff',
            }
        });

    },
    toastSuccess: (message, duration = 4000) => {
        toast.success(message, {
            duration,
            style: {
                // borderRadius: '10px',
                background: '#333',
                color: '#fff',
            }
        });
    },
    toastError: (message, duration = 4000) => {
        toast.error(message, {
            duration,
            style: {
                // borderRadius: '10px',
                background: '#333',
                color: '#fff',
            }
        });
    }
}